import type { ReactElement } from "react";
import styles from "../PaymentActivity.module.scss";

type InvoiceDownloadLinkProps = {
  invoice: NonNullable<API.PaymentActivity["invoice"]>;
};

const getInvoiceDownloadHref = (s3Key: string): string =>
  `/v1/invoices/download/${s3Key
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/")}`;

const getInvoiceFileName = (
  invoice: NonNullable<API.PaymentActivity["invoice"]>
): string => invoice.original_filename.trim() || invoice.uuid;

const InvoiceDownloadLink = ({
  invoice,
}: InvoiceDownloadLinkProps): ReactElement => {
  const fileName = getInvoiceFileName(invoice);

  return (
    <a
      className={styles.invoiceDownloadLink}
      href={getInvoiceDownloadHref(invoice.s3_key)}
      download={fileName}
    >
      <span
        className="narmi-icon-download margin--right--xs"
        aria-hidden="true"
      />
      <span className={styles.invoiceDownloadFileName}>{fileName}</span>
    </a>
  );
};

export default InvoiceDownloadLink;
